import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * shadcn/ui 的 `cn`。
 *
 * 照搬搬小书 `xhshub/apps/web/src/lib/utils.ts`：`extendTailwindMerge` 里登记
 * 本项目的自定义 token，否则 `text-callout` 会被当成**颜色**、`rounded-control`
 * 认不出来 —— 合并时会把类名吃掉（表现为「明明写了 text-callout 却是 14px」）。
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        'caption2',
        'caption1',
        'footnote',
        'subheadline',
        'callout',
        'body',
        'title3',
        'title2',
        'title1',
      ],
      radius: ['field', 'icon', 'control', 'card', 'sheet'],
      color: [
        'background',
        'foreground',
        'card',
        'card-foreground',
        'popover',
        'popover-foreground',
        'primary',
        'primary-foreground',
        'secondary',
        'secondary-foreground',
        'muted',
        'muted-foreground',
        'accent',
        'accent-foreground',
        'destructive',
        'destructive-foreground',
        'border',
        'input',
        'ring',
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
